// @flow
import { schema } from 'normalizr';


export const routeStopSchedule = new schema.Entity('routeStopSchedule', {}, {
  idAttribute: 'route_stop',
});
export const arrayOfRouteStopSchedules = new schema.Array(routeStopSchedule);



// WEBPACK FOOTER //
// ./src/scripts/api/schemas/routeStopSchedules.js